module.exports = __webpack_public_path__ + "img/20190612_132334_015.dc415535.jpg";